"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4542],{

/***/ 7455:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/enterprise-icon-white.0724aa26.svg","height":90,"width":78});

/***/ }),

/***/ 4669:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/msg-icon-white.8ce09d2b.svg","height":73,"width":97});

/***/ }),

/***/ 6782:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/perks-icon-white.120915aa.svg","height":92,"width":69});

/***/ }),

/***/ 2398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EndpageHeader_EndpageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/EndpageHeader/useStyles.ts


var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(param) {
    var type = param.type, elevation = param.elevation, brandColors = param.brandColors, breakpoints = param.breakpoints, spacing = param.spacing;
    return {
        "@keyframes notice": {
            "20%": {
                top: 0
            },
            "80%": {
                top: 0
            }
        },
        header: function(param) {
            var headerColor = param.headerColor, hasLogo = param.hasLogo;
            return (0,_define_property/* default */.Z)({
                zIndex: elevation.sky,
                color: brandColors.neutral.white,
                backgroundColor: brandColors.primary[headerColor],
                flexDirection: hasLogo ? "column" : "row"
            }, "@media (max-width: ".concat(breakpoints.md, "px)"), {
                flexDirection: "column"
            });
        },
        thanks: {
            position: "absolute",
            top: "-500px",
            boxSizing: "border-box",
            width: "100%",
            animationName: "$notice",
            animationDuration: "7s",
            animationDelay: "2s"
        },
        icon: {
            fontSize: type.fontSize.pageTitle,
            color: brandColors.neutral.white,
            marginRight: spacing[2],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
                stroke: brandColors.neutral.white,
                strokeWidth: 0.5,
                overflow: "visible"
            }
        },
        logo: (0,_define_property/* default */.Z)({
            fontSize: type.fontSize.pageTitle + 6,
            marginBottom: spacing[3]
        }, "@media (max-width: ".concat(breakpoints.md, "px)"), {
            marginBottom: spacing[1]
        }),
        copy: (0,_define_property/* default */.Z)({
            color: brandColors.neutral.white,
            fontWeight: 500
        }, "@media (max-width: ".concat(breakpoints.md, "px)"), {
            fontSize: type.fontSize.sectionTitle
        })
    };
});
/* harmony default export */ var EndpageHeader_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/EndpageHeader/EndpageHeader.tsx







var EndpageHeader = function(param) {
    var copy = param.copy, _hasLogo = param.hasLogo, hasLogo = _hasLogo === void 0 ? false : _hasLogo, _headerColor = param.headerColor, headerColor = _headerColor === void 0 ? "concord" : _headerColor, headerType = param.headerType, icon = param.icon;
    var ref = EndpageHeader_useStyles({
        headerColor: headerColor,
        hasLogo: hasLogo
    }), header = ref.header, thanks = ref.thanks, iconClass = ref.icon, logo = ref.logo, copyClass = ref.copy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
        p: 6,
        display: "flex",
        flexJustify: "center",
        className: classnames_default()(header, headerType === "thanks" ? thanks : ""),
        "data-testid": "EndpageHeader",
        children: [
            hasLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* Logo */.T, {
                className: logo,
                color: "alt"
            }),
            icon && !hasLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: iconClass,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Typography */.ZT, {
                color: "light",
                component: "span",
                variant: "pageTitle",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: copyClass,
                    children: copy
                })
            })
        ]
    });
};
/* harmony default export */ var EndpageHeader_EndpageHeader = (EndpageHeader);

;// CONCATENATED MODULE: ./src/app/components/EndpageHeader/index.ts



/***/ }),

/***/ 1737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FortuneCallout_FortuneCallout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var utils_dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./src/app/components/core/Button/index.ts + 1 modules
var Button = __webpack_require__(5709);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/FortuneCallout/useStyles.ts

var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        container: function(param) {
            var color = param.color;
            var backgroundColor = function() {
                if (color === "sabaeus") {
                    return theme.brandColors.primary.sabaeus;
                }
                if (color === "canvas") {
                    return theme.brandColors.neutral.canvas;
                }
                return undefined;
            };
            return {
                backgroundColor: backgroundColor(),
                padding: theme.spacing[7]
            };
        },
        button: function(param) {
            var color = param.color;
            return {
                "& > *": {
                    backgroundColor: color === "sabaeus" ? theme.brandColors.neutral.white : undefined,
                    borderColor: color === "sabaeus" ? theme.brandColors.neutral.white : undefined,
                    color: color === "sabaeus" ? theme.brandColors.primary.sabaeus : undefined,
                    "&:hover, &:focus": {
                        backgroundColor: color === "sabaeus" ? theme.endpageColors.onHover.transparentWhite : undefined,
                        borderColor: color === "sabaeus" ? theme.endpageColors.onHover.transparentWhite : undefined,
                        textDecoration: "none"
                    },
                    "&:focus-visible": {
                        // default focus outline not visible for some reason, so we have to apply manually
                        outline: "2px solid #007aff"
                    }
                }
            };
        },
        copyElement: {
            maxWidth: 550
        },
        copyText: {
            fontWeight: 500
        }
    };
});
/* harmony default export */ var FortuneCallout_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/FortuneCallout/FortuneCallout.tsx








var FortuneCallout = function(param) {
    var _color = param.color, color = _color === void 0 ? "canvas" : _color, copy = param.copy, _copyTag = param.copyTag, copyTag = _copyTag === void 0 ? "h3" : _copyTag, ctaText = param.ctaText, utSource = param.utSource, utSource2 = param.utSource2, _hideCTAs = param.hideCTAs, hideCTAs = _hideCTAs === void 0 ? false : _hideCTAs, _route = param.route, route = _route === void 0 ? "/user/sign-up/" : _route;
    var ref = FortuneCallout_useStyles({
        color: color
    }), container = ref.container, button = ref.button, copyElement = ref.copyElement, copyText = ref.copyText;
    var utSource3 = "FortuneCallout";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        "data-testid": "FortuneCallout",
        display: "flex",
        flexAlign: "center",
        flexDirection: "column",
        className: container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                className: copyElement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                    component: copyTag,
                    align: "center",
                    variant: "sectionTitle",
                    color: color === "sabaeus" ? "light" : "primary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: copyText,
                        children: copy
                    })
                })
            }),
            !hideCTAs && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                mt: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: button,
                    size: "lg",
                    href: (0,utils_dist.createURL)(route, {
                        ut_source: utSource,
                        ut_source2: utSource2,
                        ut_source3: utSource3,
                        ut_ctatext: ctaText
                    }),
                    "data-sm-metric": (0,dist.generateMetricsAttribute)({
                        data: {
                            actionType: "".concat(utSource, "_click_fortune_cta_to_sign_up"),
                            actionFlow: {
                                utSource: utSource
                            }
                        }
                    }),
                    children: ctaText
                })
            })
        ]
    });
};
/* harmony default export */ var FortuneCallout_FortuneCallout = (FortuneCallout);

;// CONCATENATED MODULE: ./src/app/components/FortuneCallout/index.ts



/***/ }),

/***/ 6399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_HeroFormCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var index_es = __webpack_require__(7837);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var typography_dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/grid/dist/index.es.js
var grid_dist_index_es = __webpack_require__(8597);
// EXTERNAL MODULE: ./node_modules/@wds/input/dist/index.es.js + 1 modules
var input_dist_index_es = __webpack_require__(7634);
// EXTERNAL MODULE: ./node_modules/@wds/checkbox/dist/index.es.js
var checkbox_dist_index_es = __webpack_require__(7277);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/StaticContext/index.js
var StaticContext = __webpack_require__(6787);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Recaptcha/index.js + 1 modules
var Recaptcha = __webpack_require__(6537);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/components/core/Button/index.ts + 1 modules
var Button = __webpack_require__(5709);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/static/images/logos/facebook.png
/* harmony default export */ var facebook = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/facebook.a94c5189.png","height":41,"width":42,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9klEQVR42mOwiZx+xTZqxm8g/cUhZsZXWa9JXxkser9IeU36ZR894w4DUPIpEP93jJn5Xztgyv/m/s3/X77++P/gsWv/GWz73jMAdT4C4v9u8bP+MTC0/L//6NX/t+8+/avr2vDfJHTqa5AJj4FG/TcLm/avZ/r2/58+f/9/9cbjfxmVy/+bh017A1YAMl7Ga9K/W3ef/YeCf3sOXfnPYNIDVvAIiP87xc78x+A04f/zlx/+Hzh27R+DXvd/94RZr0FueApVAHLU/xevgAqOXv3PoNcFUvAeZMIlIP4NVPCFwbH/6+Nnb3/vO3z1B4Nx90/3hFm3AeyWneQq7RFtAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/static/images/logos/google.png
/* harmony default export */ var google = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/google.8c73b61c.png","height":42,"width":41,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA8klEQVR42mMAgVuB6qLX1LVWXtfQ/H9NQwuEr1/T0PFhAIFDDKZCVxm0b17XBEqqa+0ASiy6pqH995qmbjkDCLxbzzPtXpby/8sMOvEMUPCfgYGZAQa+HGN49vUww20GIFi0ioExqW73toiG/fdi6/aeBeLjDD8OMzx4e5DzEQMUxDbsWRNXt+9UbP3ebzF1+/4zXN6j0F653ua/wCrXSgYoiGreIhNXc/BHTP3eywwMxXnsOqtcDrqvcfrvstrlmssa+4PuK8L+h/Ut+ptQctqaAQQWbTVmc17t3Oa6xumx62qX985rLbZbb2MwYmBgYAAAA2NkXnQmTs8AAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/app/helpers/assetLoading.ts
var assetLoading = __webpack_require__(98);
;// CONCATENATED MODULE: ./src/app/components/HeroFormCTA/useStyles.ts






var useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        ctaFormField: function(param) {
            var isEnterpriseThankYou = param.isEnterpriseThankYou;
            var inputBase = {
                fontSize: "15px",
                padding: [
                    0,
                    theme.spacing[3]
                ]
            };
            if (isEnterpriseThankYou) {
                return {
                    margin: "0 auto",
                    padding: [
                        theme.spacing[3],
                        0,
                        0,
                        0
                    ],
                    width: "224px",
                    "@media (max-width: 374px)": {
                        height: "62px"
                    },
                    // The wrench input used does not allow addition of a classname
                    "& input": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputBase), {
                        height: "50px",
                        "@media (max-width: 374px)": {
                            height: "48px"
                        }
                    }),
                    "& label > span": {
                        color: theme.palette.text.light
                    }
                };
            }
            return {
                margin: 0,
                padding: [
                    theme.spacing[1],
                    0,
                    theme.spacing[3]
                ],
                "& input": inputBase
            };
        },
        ctaLabel: {
            display: "block",
            boxSizing: "border-box",
            marginBottom: "4px",
            // The wrench button used does not allow addition of a classname
            "& > span": {
                fontSize: "13px",
                lineHeight: "1.5em",
                fontWeight: 500
            }
        },
        visuallyHidden: {
            clip: " rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            width: "1px",
            overflow: "hidden",
            position: "absolute",
            whiteSpace: "nowrap"
        },
        hardRule: function(param) {
            var isEnterpriseThankYou = param.isEnterpriseThankYou;
            return {
                borderTop: isEnterpriseThankYou ? "none" : [
                    2,
                    "solid",
                    theme.palette.border.main
                ],
                width: isEnterpriseThankYou ? 0 : "100%"
            };
        },
        /** Only applies to `enterpriseThankYou` */ enterpriseThankYouForm: {
            // The wrench button used does not allow addition of a classname
            "& button": {
                backgroundColor: theme.palette.background.light,
                height: "50px",
                width: "140px",
                margin: [
                    20,
                    "auto",
                    0
                ],
                padding: 0,
                color: theme.palette.text.dark,
                border: [
                    1,
                    "solid",
                    theme.palette.text.dark
                ],
                "&:hover, &:focus": {
                    borderColor: theme.palette.border.main,
                    backgroundColor: theme.palette.background.light
                },
                "&:active": {
                    borderColor: theme.palette.border.active,
                    backgroundColor: theme.palette.background.light
                }
            }
        },
        facebookButton: {
            // The wrench button used does not allow addition of a classname
            "& > a": {
                boxSizing: "border-box",
                fontSize: "15px",
                border: "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: theme.spacing[5],
                backgroundColor: "#3d5a98",
                color: theme.palette.text.light,
                backgroundPosition: "10% 41%",
                backgroundImage: "url(".concat((0,assetLoading/* getSrc */.d)(facebook), ")"),
                "&:focus, &:hover": {
                    backgroundColor: "#4a71c3",
                    textDecoration: "none"
                },
                "& > span": {
                    marginLeft: theme.spacing[4]
                }
            }
        },
        googleButton: {
            // The wrench button used does not allow addition of a classname
            "& > a": {
                boxShadow: "0 0 1px 0 rgba(0, 0, 0, 0.12), 0 0 8px 0 rgba(0, 0, 0, 0.12)",
                boxSizing: "border-box",
                fontSize: "15px",
                border: "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: theme.spacing[5],
                backgroundColor: theme.palette.background.light,
                color: theme.palette.text.darkMuted,
                backgroundPosition: "13% 50%",
                backgroundImage: "url(".concat((0,assetLoading/* getSrc */.d)(google), ")"),
                "&:focus, &:hover": {
                    backgroundColor: theme.palette.background.main,
                    textDecoration: "none"
                },
                "& > span": {
                    marginLeft: theme.spacing[4]
                }
            }
        },
        disclaimerContainer: {
            "& a": {
                color: theme.palette.link.main
            }
        }
    };
});
/* harmony default export */ var useStyles = (useStyle);

;// CONCATENATED MODULE: ./src/app/components/HeroFormCTA/index.tsx














/** Type-wrapper for `Typography` to allow use of `dangerouslySetInnerHTML`  */ var TypographyWithInnerHTML = typography_dist_index_es/* Typography */.ZT;
var HeroFormCTA = function(param) {
    var className = param.className, ctaFormEmail = param.ctaFormEmail, ctaFormEmailPlaceholder = param.ctaFormEmailPlaceholder, ctaFormNewsletterOptOut = param.ctaFormNewsletterOptOut, ctaFormPassword = param.ctaFormPassword, ctaFormPasswordPlaceholder = param.ctaFormPasswordPlaceholder, ctaFormPrivacyConsent = param.ctaFormPrivacyConsent, ctaFormSubmit = param.ctaFormSubmit, _ctaFacebook = param.ctaFacebook, ctaFacebook = _ctaFacebook === void 0 ? "FACEBOOK" : _ctaFacebook, _ctaGoogle = param.ctaGoogle, ctaGoogle = _ctaGoogle === void 0 ? "GOOGLE" : _ctaGoogle, disclaimer = param.disclaimer, _utSource = param.utSource, utSource = _utSource === void 0 ? "" : _utSource, _utSource2 = param.utSource2, utSource2 = _utSource2 === void 0 ? "" : _utSource2, _showThirdPartySignUpActions = param.showThirdPartySignUpActions, showThirdPartySignUpActions = _showThirdPartySignUpActions === void 0 ? true : _showThirdPartySignUpActions, _showDisclaimer = param.showDisclaimer, showDisclaimer = _showDisclaimer === void 0 ? true : _showDisclaimer, isEnterpriseThankYou = param.isEnterpriseThankYou;
    var utSource3 = "HeroFormCTA";
    var ref = (0,react.useContext)(StaticContext/* StaticContext */.vN), countryCode = ref.environment.countryCode;
    var ref1 = useStyles({
        isEnterpriseThankYou: isEnterpriseThankYou
    }), hardRule = ref1.hardRule, enterpriseThankYouForm = ref1.enterpriseThankYouForm, ctaFormField = ref1.ctaFormField, ctaLabel = ref1.ctaLabel, visuallyHidden = ref1.visuallyHidden, facebookButton = ref1.facebookButton, googleButton = ref1.googleButton, disclaimerContainer = ref1.disclaimerContainer;
    var containerClasses = classnames_default()("sm-hero-form-cta", className);
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), password = ref3[0], setPassword = ref3[1];
    var handleEmailChange = function(e) {
        setEmail(e.target.value);
    };
    var handlePasswordChange = function(e) {
        setPassword(e.target.value);
    };
    var recaptchaContext = (0,Recaptcha/* useRecaptcha */.Z)({
        actionName: "user_signup",
        successCallback: undefined,
        siteKey: undefined,
        useEnterprise: undefined,
        errorCallback: undefined
    });
    // submits the form action when reCAPTCHA sets the token properly
    (0,react.useEffect)(function() {
        if (recaptchaContext.greToken.length) {
            document.getElementById("signup_form").submit();
        }
    }, [
        recaptchaContext.greToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
        className: containerClasses,
        pt: 7,
        "data-testid": "HeroFormCTA",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                id: "signup_form",
                method: "post",
                action: (0,dist.createURL)("/user/sign-up/", {
                    ut_source: utSource,
                    ut_source2: utSource2,
                    ut_source3: utSource3,
                    ut_ctatext: ctaFormSubmit
                }),
                className: isEnterpriseThankYou ? enterpriseThankYouForm : undefined,
                "data-testid": "HeroFormCTA__Form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Recaptcha/* Recaptcha */.e, {
                        greToken: recaptchaContext.greToken,
                        showError: recaptchaContext.showError,
                        setShowError: recaptchaContext.setShowError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "username",
                        className: "input-username",
                        value: email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "password_confirm",
                        className: "input-password_confirm",
                        value: password
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
                        element: "div",
                        className: ctaFormField,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: isEnterpriseThankYou ? visuallyHidden : ctaLabel,
                                htmlFor: "email-input",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                                    component: "span",
                                    variant: "bodySm",
                                    children: ctaFormEmail
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_es/* Input */.I, {
                                id: "email-input",
                                type: "email",
                                name: "email",
                                placeholder: ctaFormEmailPlaceholder,
                                required: true,
                                stretched: true,
                                onChange: handleEmailChange,
                                value: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
                        element: "div",
                        className: ctaFormField,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: isEnterpriseThankYou ? visuallyHidden : ctaLabel,
                                htmlFor: "password-input",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                                    component: "span",
                                    variant: "bodySm",
                                    children: ctaFormPassword
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_es/* Input */.I, {
                                id: "password-input",
                                type: "password",
                                name: "password",
                                placeholder: ctaFormPasswordPlaceholder,
                                required: true,
                                stretched: true,
                                onChange: handlePasswordChange,
                                value: password
                            })
                        ]
                    }),
                    countryCode.toLowerCase() === "de" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                                element: "div",
                                className: ctaFormField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_es/* Checkbox */.X, {
                                    // weird required type from Wrench due to merge of HTMLAttribute and custom type
                                    // ((boolean | ReactChild | ReactFragment | ReactPortal | null) & string) | undefined
                                    label: ctaFormPrivacyConsent,
                                    id: "privacy-consents",
                                    name: "privacy-consents",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                                element: "div",
                                className: ctaFormField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_es/* Checkbox */.X, {
                                    label: ctaFormNewsletterOptOut,
                                    id: "subscribe-to-newsletter",
                                    name: "subscribe-to-newsletter"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        size: "lg",
                        stretched: true,
                        onClick: recaptchaContext.fireGRE,
                        children: ctaFormSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                mb: 4,
                mt: 4,
                className: hardRule,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }),
            showThirdPartySignUpActions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_dist_index_es/* Grid */.r, {
                noBleeds: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_dist_index_es/* Grid.Item */.r.Item, {
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: facebookButton,
                            stretched: true,
                            href: (0,dist.createURL)("/user/third-party/", {
                                third_party: "facebook",
                                action: "sign_up"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaFacebook
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_dist_index_es/* Grid.Item */.r.Item, {
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: googleButton,
                            stretched: true,
                            href: (0,dist.createURL)("/user/third-party/", {
                                third_party: "google",
                                action: "sign_up"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaGoogle
                            })
                        })
                    })
                ]
            }),
            showDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                mt: 3,
                className: disclaimerContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyWithInnerHTML, {
                    align: "center",
                    component: "div",
                    variant: "bodySm",
                    color: "darkMuted",
                    dangerouslySetInnerHTML: {
                        __html: "".concat(disclaimer)
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_HeroFormCTA = (HeroFormCTA);


/***/ }),

/***/ 4071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductsCalloutList_ProductsCalloutList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/grid/dist/index.es.js
var dist_index_es = __webpack_require__(8597);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var typography_dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/components/core/Button/index.ts + 1 modules
var Button = __webpack_require__(5709);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/ProductCalloutItem/useStyles.ts


var hoverColors = {
    classic: {
        sabaeus: "#00ce78",
        midnight: "#065497"
    },
    standard: {
        sabaeus: "#bdf3dc",
        concord: "#dad1dc",
        midnight: "#a8c6e0"
    }
};
var toFontSizeNumber = function(fontSize) {
    if (typeof fontSize === "number") {
        return fontSize;
    }
    return Number.parseFloat(fontSize);
};
var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var brandColors = theme.brandColors.primary;
    return {
        container: (0,_define_property/* default */.Z)({
            textAlign: "center"
        }, "@media (min-width: ".concat(theme.breakpoints.lg, "px)"), {
            maxWidth: "700px"
        }),
        copy: {
            width: "66%",
            "& p": {
                fontSize: "".concat(toFontSizeNumber(theme.type.fontSize.body) * 1.25, "px")
            }
        },
        logo: {
            height: "80px"
        },
        button: function(param) {
            var ctaColor = param.ctaColor;
            var backgroundColor = function(hover) {
                if (!hover) {
                    return ctaColor.includes("classic") ? brandColors[ctaColor.split("-")[1]] : "#FFF";
                }
                if (hover) {
                    return ctaColor.includes("classic") ? hoverColors.classic[ctaColor.split("-")[1]] : hoverColors.standard[ctaColor];
                }
                return "#fff";
            };
            return {
                "& > *": {
                    color: ctaColor.includes("classic") ? "#fff" : brandColors[ctaColor],
                    backgroundColor: backgroundColor(),
                    borderColor: backgroundColor(),
                    "&:hover, &:focus": {
                        backgroundColor: backgroundColor(true),
                        borderColor: backgroundColor(true),
                        textDecoration: "none"
                    },
                    "&:focus-visible": {
                        // default focus outline not visible for some reason, so we have to apply manually
                        outline: "2px solid #007aff"
                    }
                }
            };
        }
    };
});
/* harmony default export */ var ProductCalloutItem_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/ProductCalloutItem/ProductCalloutItem.tsx








var ProductCalloutItem = function(param) {
    var icon = param.icon, _iconAlt = param.iconAlt, iconAlt = _iconAlt === void 0 ? "" : _iconAlt, heading = param.heading, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h3" : _headingTag, copy = param.copy, href = param.href, utSource = param.utSource, cta = param.cta, ctaColor = param.ctaColor, name = param.name, className = param.className, _hideCTAs = param.hideCTAs, hideCTAs = _hideCTAs === void 0 ? false : _hideCTAs, _color = param.color, color = _color === void 0 ? "light" : _color;
    var ref = ProductCalloutItem_useStyles({
        ctaColor: ctaColor
    }), container = ref.container, copyClass = ref.copy, logoClass = ref.logo, button = ref.button;
    var containerClasses = classnames_default()(container, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        display: "flex",
        flexDirection: "column",
        flexAlign: "center",
        pr: 5,
        pl: 5,
        pb: 7,
        pt: 7,
        "data-testid": "ProductCalloutItem",
        className: containerClasses,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                mb: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    alt: iconAlt,
                    role: !iconAlt ? "presentation" : undefined,
                    src: icon,
                    className: logoClass
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                component: headingTag,
                color: color,
                variant: "sectionTitle",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    "data-testid": "ProductCalloutItem__Heading",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                mt: 5,
                mb: 5,
                className: copyClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                    color: color,
                    component: "p",
                    variant: "body",
                    align: "center",
                    children: copy
                })
            }),
            !hideCTAs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: button,
                href: href,
                size: "lg",
                "data-sm-metric": (0,dist.generateMetricsAttribute)({
                    data: {
                        actionType: "".concat(utSource, "_click_").concat(name, "_cta_to_sign_up"),
                        actionFlow: {
                            utSource: utSource
                        }
                    }
                }),
                children: cta
            })
        ]
    });
};
/* harmony default export */ var ProductCalloutItem_ProductCalloutItem = (ProductCalloutItem);

;// CONCATENATED MODULE: ./src/app/components/ProductCalloutItem/index.ts


;// CONCATENATED MODULE: ./src/app/components/ProductsCalloutList/useStyles.ts


var useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var brandColors = theme.brandColors.primary;
    var _itemColor1, _itemColor2;
    return {
        item1: function(param) {
            var itemColor1 = param.itemColor1;
            return (0,_define_property/* default */.Z)({
                backgroundColor: (_itemColor1 = brandColors[itemColor1]) !== null && _itemColor1 !== void 0 ? _itemColor1 : "#FFF",
                height: "100%",
                display: "flex",
                justifyContent: "flex-end"
            }, "@media (max-width: ".concat(theme.breakpoints.lg, "px)"), {
                justifyContent: "center"
            });
        },
        item2: function(param) {
            var itemColor2 = param.itemColor2;
            return {
                backgroundColor: (_itemColor2 = brandColors[itemColor2]) !== null && _itemColor2 !== void 0 ? _itemColor2 : "#FFF",
                height: "100%"
            };
        }
    };
});
/* harmony default export */ var ProductsCalloutList_useStyles = (useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/ProductsCalloutList/ProductsCalloutList.tsx








var ProductsCalloutList = function(param) {
    var calloutItem1 = param.calloutItem1, calloutItem2 = param.calloutItem2, utSource = param.utSource, _hideCTAs = param.hideCTAs, hideCTAs = _hideCTAs === void 0 ? false : _hideCTAs;
    var ref = ProductsCalloutList_useStyles({
        itemColor1: calloutItem1.ctaColor,
        itemColor2: calloutItem2.ctaColor
    }), item1 = ref.item1, item2 = ref.item2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
        "data-testid": "ProductsCalloutList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Grid */.r, {
            fluid: true,
            noGutters: true,
            noBleeds: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Grid.Item */.r.Item, {
                    lg: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                        className: item1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCalloutItem_ProductCalloutItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, calloutItem1), {
                            utSource: utSource,
                            hideCTAs: hideCTAs
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Grid.Item */.r.Item, {
                    lg: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                        className: item2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCalloutItem_ProductCalloutItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, calloutItem2), {
                            utSource: utSource,
                            hideCTAs: hideCTAs
                        }))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsCalloutList_ProductsCalloutList = (ProductsCalloutList);

;// CONCATENATED MODULE: ./src/app/components/ProductsCalloutList/index.ts



/***/ }),

/***/ 3715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RebrandEpFormCore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var utils_dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/SimpleLogoHeader/useStyles.ts


var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var mediaQueryMinScreenLG = "@media (min-width: ".concat(theme.breakpoints.lg, "px)");
    return {
        header: {
            // uses wider breakpoint than Wrench
            maxWidth: 1440,
            margin: "0 auto"
        },
        text: {
            fontSize: theme.type.fontSize.hero2
        },
        logo: {
            width: "247px",
            height: "37px",
            display: "block"
        },
        goldie: {
            width: "40px",
            height: "28px",
            "&:focus, &:hover": {
                textDecoration: "none"
            }
        },
        mobileLogo: (0,_define_property/* default */.Z)({
            display: "flex"
        }, mediaQueryMinScreenLG, {
            display: "none"
        }),
        desktopLogo: (0,_define_property/* default */.Z)({
            display: "none"
        }, mediaQueryMinScreenLG, {
            display: "block"
        })
    };
});
/* harmony default export */ var SimpleLogoHeader_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/SimpleLogoHeader/index.tsx







var COPY = (0,dist/* defineMessages */.vU)({
    LOGO_ARIA_LABEL: {
        id: "SimpleLogoHeader.LogoAriaLabel",
        defaultMessage: "SurveyMonkey Home",
        description: "[Type: Header][Vis: med] - The SurveyMonkey Logo shown at the top of the page"
    }
});
var SimpleLogoHeader = function(param) {
    var utSource = param.utSource, utSource2 = param.utSource2;
    var ref = SimpleLogoHeader_useStyles(), header = ref.header, logo = ref.logo, text = ref.text, goldie = ref.goldie, mobileLogo = ref.mobileLogo, desktopLogo = ref.desktopLogo;
    var utSource3 = "SimpleLogoHeader";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        "data-testid": "SimpleLogoHeader__Container",
        className: header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                mt: 6,
                display: "flex",
                flexJustify: "center",
                className: mobileLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "aria-label": (0,dist.t)(COPY.LOGO_ARIA_LABEL),
                    "data-testid": "SimpleLogoHeader__Goldie",
                    href: (0,utils_dist.createURL)("/", {
                        ut_source: utSource,
                        ut_source2: utSource2,
                        ut_source3: utSource3,
                        ut_ctatext: "Logo"
                    }),
                    className: goldie,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* Logo */.T, {
                        className: text
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                mt: 7,
                ml: 7,
                display: "block",
                className: desktopLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "aria-label": (0,dist.t)(COPY.LOGO_ARIA_LABEL),
                    "data-testid": "SimpleLogoHeader__Logo",
                    href: (0,utils_dist.createURL)("/", {
                        ut_source: utSource,
                        ut_source2: utSource2,
                        ut_source3: utSource3,
                        ut_ctatext: "LogoWithText"
                    }),
                    className: logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* LogoWithText */.u, {
                        className: text
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_SimpleLogoHeader = (SimpleLogoHeader);

// EXTERNAL MODULE: ./src/app/components/SimpleHero/index.ts + 2 modules
var SimpleHero = __webpack_require__(2203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/MediaComponents/index.js
var MediaComponents = __webpack_require__(5078);
// EXTERNAL MODULE: ./src/app/components/HeroFormCTA/index.tsx + 3 modules
var HeroFormCTA = __webpack_require__(6399);
;// CONCATENATED MODULE: ./src/static/images/rebrand_focus.png
/* harmony default export */ var rebrand_focus = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/rebrand_focus.72f7bcf2.png","height":640,"width":813,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAArklEQVR42mMAgeL4StFpVaVNDEhgfWel5MLaQmUwJ7evTaxkZnMlQ9QvtqlloRVqDAwzJ3ZO01k3d5Etw5ppS5hgulZ0VZ18tL7k/8auvP9HZoo3MyABsKJfZyY+f3l03v/HD+7//3p752UGENgwZaLfxrkzvjLceCvx7uH12iN7t/+/fPPm/x2HtmcwgMD7uFirT0Xp+xZs2SIH4qeY8CjOOXVaj6H3BCcDAwMDAK1ZSmojGv6AAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/app/helpers/assetLoading.ts
var assetLoading = __webpack_require__(98);
;// CONCATENATED MODULE: ./src/app/components/HeroFormCallout/useStyles.ts




var useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var mediaQueryMinScreenSM = "@media (min-width: ".concat(theme.breakpoints.sm, "px)");
    var mediaQueryMinScreenMD = "@media (min-width: ".concat(theme.breakpoints.md, "px)");
    var mediaQueryMinScreenLG = "@media (min-width: ".concat(theme.breakpoints.lg, "px)");
    var mediaQueryMinScreenXL = "@media (min-width: ".concat(theme.breakpoints.xl, "px)");
    var _obj, _obj1, _obj2;
    return {
        wrapper: (_obj = {
            padding: "20px 20px 50px",
            maxWidth: "1400px",
            margin: "0 auto",
            overflowX: "hidden",
            alignItems: "center"
        }, (0,_define_property/* default */.Z)(_obj, mediaQueryMinScreenSM, {
            padding: "40px 60px 100px"
        }), (0,_define_property/* default */.Z)(_obj, mediaQueryMinScreenLG, {
            padding: "80px 0 100px 100px",
            alignItems: "flex-start"
        }), (0,_define_property/* default */.Z)(_obj, mediaQueryMinScreenXL, {
            padding: "80px 0 100px 165px"
        }), _obj),
        image: (_obj1 = {
            backgroundImage: "url(".concat((0,assetLoading/* getSrc */.d)(rebrand_focus), ")"),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            position: "relative",
            top: "70px"
        }, (0,_define_property/* default */.Z)(_obj1, mediaQueryMinScreenMD, {
            width: "550px",
            height: "433px",
            left: "150px"
        }), (0,_define_property/* default */.Z)(_obj1, mediaQueryMinScreenLG, {
            width: "620px",
            height: "504px",
            left: "240px"
        }), _obj1),
        ctaForm: {
            margin: "0 auto",
            maxWidth: "380px"
        },
        header: (0,_define_property/* default */.Z)({
            // The wrench Typography used does not allow addition of a classname
            "& > section": (_obj2 = {
                textAlign: "center",
                width: "100%",
                maxWidth: "1020px"
            }, (0,_define_property/* default */.Z)(_obj2, mediaQueryMinScreenMD, {
                fontSize: "34px"
            }), (0,_define_property/* default */.Z)(_obj2, mediaQueryMinScreenLG, {
                textAlign: "left",
                fontSize: "50px"
            }), _obj2)
        }, mediaQueryMinScreenLG, {
            width: "100%"
        }),
        subHeader: (0,_define_property/* default */.Z)({
            fontWeight: theme.type.fontWeight.regular,
            width: "100%",
            maxWidth: "1020px",
            "&, & div": {
                textAlign: "center"
            }
        }, mediaQueryMinScreenLG, {
            maxWidth: "480px",
            "&, & div": {
                textAlign: "left"
            }
        }),
        bold: {
            fontWeight: 500
        }
    };
});
/* harmony default export */ var HeroFormCallout_useStyles = (useStyle);

;// CONCATENATED MODULE: ./src/app/components/HeroFormCallout/index.tsx








var HeroFormCallout = function(param) {
    var color = param.color, boldHeader = param.boldHeader, subHeaderContent = param.subHeader, formCopy = param.formCopy;
    var ref = HeroFormCallout_useStyles(), wrapper = ref.wrapper, image = ref.image, ctaForm = ref.ctaForm, header = ref.header, subHeader = ref.subHeader, bold = ref.bold;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        display: "flex",
        flexJustify: "center",
        flexDirection: "column",
        "data-testid": "HeroFormCallout",
        className: wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
                className: header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                        component: "section",
                        variant: "sectionTitle",
                        color: color,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: bold,
                            children: boldHeader
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                        pt: 3,
                        className: subHeader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                            component: "div",
                            variant: "body",
                            color: color,
                            children: subHeaderContent
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroFormCTA/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: ctaForm
                    }, formCopy)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaComponents/* TabletScreen */.m6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: image
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_HeroFormCallout = (HeroFormCallout);

// EXTERNAL MODULE: ./src/app/components/FortuneCallout/index.ts + 2 modules
var FortuneCallout = __webpack_require__(1737);
// EXTERNAL MODULE: ./src/app/components/ProductsCalloutList/index.ts + 5 modules
var ProductsCalloutList = __webpack_require__(4071);
;// CONCATENATED MODULE: ./src/app/components/RebrandEpFormCore/index.tsx








var RebrandEpFormCore_COPY = (0,dist/* defineMessages */.vU)({
    HERO_FORM_CALLOUT_BOLD_HEADER: {
        id: "RebrandEpFormCore.HeroFormCalloutBoldHeader",
        defaultMessage: "Want to create your own surveys?",
        description: "[Type: Header][Vis: high] - The Hero's Primary tagline. A question to put into context the subheader beneath this tagline, and to entice users to fillout and submit the form directly below the header."
    },
    HERO_FORM_CALLOUT_SUBHEADER: {
        id: "RebrandEpFormCore.HeroFormCalloutSubHeader",
        defaultMessage: "Gather opinions from customers, employees, prospects, and more. Use your insights to make better, data-driven decisions.",
        description: "[Type: Header][Vis: high] - The Hero's subheader. A value proposition, giving a clear example of what they can get if they fill out the form below."
    },
    HERO_FORM_CTA_EMAIL_ADDRESS: {
        id: "RebrandEpFormCore.HeroFormCTAEmailAddress",
        defaultMessage: "Email Address",
        description: "[Type: Label][Vis: high] - The Label for an email input field."
    },
    HERO_FORM_CTA_EMAIL_ADDRESS_PLACEHOLDER: {
        id: "RebrandEpFormCore.HeroFormCTAEmailAddressPlaceholder",
        defaultMessage: "you@example.com",
        description: "[Type: Label][Vis: high] - The placeholder for an email input field."
    },
    HERO_FORM_CTA_PASSWORD: {
        id: "RebrandEpFormCore.HeroFormCTAPassword",
        defaultMessage: "Password",
        description: "[Type: Label][Vis: high] - The Label for a password input field."
    },
    HERO_FORM_CTA_PASSWORD_PLACEHOLDER: {
        id: "RebrandEpFormCore.HeroFormCTAPasswordPlaceholder",
        defaultMessage: "(at least 8 characters)",
        description: "[Type: Label][Vis: high] - The placeholder for a password input field."
    },
    HERO_FORM_CTA_PRIVACY_CONSENT: {
        id: "RebrandEpFormCore.HeroFormCTAPrivacyConsent",
        defaultMessage: 'I agree to the <a href="/mp/legal/terms-of-use/">Terms of Use</a> and understand my data will be handled in accordance with the <a href="/mp/legal/privacy-policy/">Privacy Policy</a>.',
        description: "[Type: Label][Vis: high] - The Label for a checkbox consenting to the Terms of Use and Privacy Policy. Only for users located in Germany."
    },
    HERO_FORM_CTA_NEWSLETTER_OPTOUT: {
        id: "RebrandEpFormCore.HeroFormCTANewsletterOptOut",
        defaultMessage: "I do not want to receive information and offers relevant to SurveyMonkey services via email. You can also opt-out of these emails in your My Account page anytime.",
        description: "[Type: Label][Vis: high] - The Label for a checkbox to opt out of Newsletter subscription. Only for users located in Germany."
    },
    HERO_FORM_CTA_SUBMIT: {
        id: "RebrandEpFormCore.HeroFormCTASubmit",
        defaultMessage: "Create Free Account",
        description: "[Type: Button][Vis: high] - The button users are required to click to create an account using the values they entered in the email and password feilds."
    },
    HERO_FORM_CTA_DISCLAIMER: {
        id: "RebrandEpFormCore.HeroFormCTADisclaimer",
        defaultMessage: 'By clicking “CREATE FREE ACCOUNT” or Facebook or Google, you agree to the <a href="/mp/legal/terms-of-use/">Terms of Use</a> and <a href="/mp/legal/privacy-policy/">Privacy Policy</a>. You also agree to receive information and offers relevant to our services via email. You can opt-out of these emails in your My Account page anytime.',
        description: "[Type: Button][Vis: high] - A legal disclaimer containing links to legal documents Terms of Service and Privacy Policy"
    },
    FORTUNE_CALLOUT_COPY: {
        id: "RebrandEpFormCore.FortuneCalloutCopy",
        defaultMessage: "95% of the Fortune 500 rely on SurveyMonkey for People Powered Data",
        description: "[Type: Header][Vis: low] - A promotional statistic designed to show corporate trust and prestige"
    },
    FORTUNE_CALLOUT_CTA: {
        id: "RebrandEpFormCore.FortuneCalloutCTA",
        defaultMessage: "SIGN UP FREE",
        description: "[Type: Button][Vis: high] - Fortune's CTA which sends people to a sign up page"
    }
});
var RebrandEpFormCore = function(param) {
    var utSource = param.utSource, calloutItem1 = param.calloutItem1, calloutItem2 = param.calloutItem2, _hideCTAs = param.hideCTAs, hideCTAs = _hideCTAs === void 0 ? false : _hideCTAs;
    var utSource2 = "RebrandEpForm";
    var HERO_FORM_CTA = {
        ctaFormEmail: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_EMAIL_ADDRESS),
        ctaFormEmailPlaceholder: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_EMAIL_ADDRESS_PLACEHOLDER),
        ctaFormNewsletterOptOut: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_NEWSLETTER_OPTOUT),
        ctaFormPassword: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_PASSWORD),
        ctaFormPasswordPlaceholder: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_PASSWORD_PLACEHOLDER),
        ctaFormPrivacyConsent: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_PRIVACY_CONSENT, {}, {
            html: true
        }),
        ctaFormSubmit: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_SUBMIT),
        disclaimer: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CTA_DISCLAIMER),
        utSource: utSource,
        utSource2: utSource2
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hideCTAs ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHero/* default */.Z, {
                    utSource: utSource,
                    utSource2: utSource2
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCalloutList/* default */.Z, {
                    calloutItem1: calloutItem1,
                    calloutItem2: calloutItem2,
                    utSource: utSource,
                    hideCTAs: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FortuneCallout/* default */.Z, {
                    copy: (0,dist.t)(RebrandEpFormCore_COPY.FORTUNE_CALLOUT_COPY),
                    ctaText: (0,dist.t)(RebrandEpFormCore_COPY.FORTUNE_CALLOUT_CTA),
                    utSource: utSource,
                    utSource2: utSource2,
                    hideCTAs: true
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimpleLogoHeader, {
                    utSource: utSource,
                    utSource2: utSource2
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroFormCallout, {
                    boldHeader: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CALLOUT_BOLD_HEADER),
                    subHeader: (0,dist.t)(RebrandEpFormCore_COPY.HERO_FORM_CALLOUT_SUBHEADER),
                    formCopy: HERO_FORM_CTA
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCalloutList/* default */.Z, {
                    calloutItem1: calloutItem1,
                    calloutItem2: calloutItem2,
                    utSource: utSource
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FortuneCallout/* default */.Z, {
                    copy: (0,dist.t)(RebrandEpFormCore_COPY.FORTUNE_CALLOUT_COPY),
                    ctaText: (0,dist.t)(RebrandEpFormCore_COPY.FORTUNE_CALLOUT_CTA),
                    utSource: utSource,
                    utSource2: utSource2
                })
            ]
        })
    });
};
/* harmony default export */ var components_RebrandEpFormCore = (RebrandEpFormCore);


/***/ }),

/***/ 2203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleHero_SimpleHero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var button_dist_index_es = __webpack_require__(7837);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var metrics_dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/MediaComponents/index.js
var MediaComponents = __webpack_require__(5078);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var utils_dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/SimpleHero/useStyles.ts


var useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var mediaQueryMinScreenSM = "@media (min-width: ".concat(theme.breakpoints.sm, "px)");
    return {
        logo: (0,_define_property/* default */.Z)({
            height: 37,
            width: "90%"
        }, mediaQueryMinScreenSM, {
            width: "auto"
        }),
        text: (0,_define_property/* default */.Z)({
            width: "90%",
            fontSize: 40
        }, mediaQueryMinScreenSM, {
            width: "auto"
        }),
        smSimpleHero: {
            backgroundColor: theme.brandColors.primary.midnight
        },
        smWebRespWebButton: {
            "& > a": {
                backgroundColor: theme.brandColors.accent.bumblebee,
                color: theme.brandColors.neutral.charcoal,
                border: "none",
                "&:hover, &:focus": {
                    backgroundColor: theme.endpageColors.onHover.lighterBumblebee,
                    textDecoration: "none"
                }
            }
        },
        smGoldie: {
            "&:hover, &:focus": {
                textDecoration: "none"
            }
        },
        heading: {
            fontWeight: "500"
        }
    };
});
/* harmony default export */ var SimpleHero_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/SimpleHero/SimpleHero.tsx











var COPY = (0,dist/* defineMessages */.vU)({
    SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER: {
        id: "SimpleHero.SimpleHero.SimpleHeroFormCalloutBoldHeader",
        defaultMessage: "Get answers with surveys",
        description: "[Type: Header][Vis: high] - The Hero's Primary tagline. A brief description of SurveyMonkey's functionality."
    },
    SIMPLE_HERO_FORM_CALLOUT_CTA: {
        id: "SimpleHero.SimpleHero.SimpleHeroFormCalloutCTA",
        defaultMessage: "CREATE SURVEY",
        description: "[Type: Header][Vis: high] - The Hero's only CTA. It takes user's to a login screen or directly to a dashboard to create their survey."
    },
    LOGO_ARIA_LABEL: {
        id: "SimpleHero.SimpleHero.LogoAriaLabel",
        defaultMessage: "SurveyMonkey Home",
        description: "[Type: Header][Vis: med] - The SurveyMonkey Logo shown at the top of the page"
    }
});
var SimpleHero = function(param) {
    var _hideCTAs = param.hideCTAs, hideCTAs = _hideCTAs === void 0 ? true : _hideCTAs, utSource = param.utSource, utSource2 = param.utSource2;
    var utSource3 = "SimpleHero";
    var ref = SimpleHero_useStyles(), smSimpleHero = ref.smSimpleHero, logo = ref.logo, smGoldie = ref.smGoldie, smWebRespWebButton = ref.smWebRespWebButton, text = ref.text, heading = ref.heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.x, {
        "data-testid": "SimpleHero",
        className: smSimpleHero,
        display: "flex",
        flexDirection: "column",
        flexAlign: "center",
        px: 3,
        pt: 7,
        pb: 8,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaComponents/* DesktopScreen */.g7, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": (0,dist.t)(COPY.LOGO_ARIA_LABEL),
                        "data-testid": "SimpleHero__Logo",
                        href: (0,utils_dist.createURL)("/", {
                            ut_source: utSource,
                            ut_source2: utSource2,
                            ut_source3: utSource3,
                            ut_ctatext: "LogoWithText"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* LogoWithText */.u, {
                            color: "alt",
                            className: logo
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                        mx: 1,
                        mt: 7,
                        mb: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                            component: "h3",
                            color: "light",
                            variant: "hero1",
                            align: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: heading,
                                children: (0,dist.t)(COPY.SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER)
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaComponents/* MobileTabletScreen */.fc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "aria-label": (0,dist.t)(COPY.LOGO_ARIA_LABEL),
                        "data-testid": "SimpleHero__Goldie",
                        href: (0,utils_dist.createURL)("/", {
                            ut_source: utSource,
                            ut_source2: utSource2,
                            ut_source3: utSource3,
                            ut_ctatext: "Logo"
                        }),
                        className: smGoldie,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* Logo */.T, {
                            color: "alt",
                            className: text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                        mx: 1,
                        mt: 7,
                        mb: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Typography */.ZT, {
                            component: "h3",
                            color: "light",
                            variant: "pageTitle",
                            align: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: heading,
                                children: (0,dist.t)(COPY.SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER)
                            })
                        })
                    })
                ]
            }),
            !hideCTAs && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.x, {
                className: smWebRespWebButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                    size: "lg",
                    color: "upgrade",
                    href: (0,utils_dist.createURL)("/create/", {
                        ut_source: utSource,
                        ut_source2: utSource2,
                        ut_source3: utSource3,
                        ut_ctatext: (0,dist.t)(COPY.SIMPLE_HERO_FORM_CALLOUT_CTA)
                    }),
                    "data-sm-metric": (0,metrics_dist.generateMetricsAttribute)({
                        data: {
                            actionType: "".concat(utSource, "_click_").concat(utSource2, "_cta_to_create"),
                            actionFlow: {
                                utSource: utSource
                            }
                        }
                    }),
                    children: (0,dist.t)(COPY.SIMPLE_HERO_FORM_CALLOUT_CTA)
                })
            })
        ]
    });
};
/* harmony default export */ var SimpleHero_SimpleHero = (SimpleHero);

;// CONCATENATED MODULE: ./src/app/components/SimpleHero/index.ts



/***/ }),

/***/ 5709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var index_es = __webpack_require__(7837);
;// CONCATENATED MODULE: ./src/app/components/core/Button/Button.tsx






/**
 * @description Generic Stylable Button.
 * This component can be used in place of the `@wds/button` component to
 * modify the styles, until the `@wds/button` version supports className prop
 * passthrough.
 */ function Button(_param) {
    var tmp = _param.element, Element = tmp === void 0 ? "div" : tmp, className = _param.className, componentProps = _param.componentProps, buttonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "element",
        "className",
        "componentProps"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, componentProps), {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, (0,_object_spread/* default */.Z)({}, buttonProps))
    }));
};

;// CONCATENATED MODULE: ./src/app/components/core/Button/index.ts




/***/ }),

/***/ 98:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getSrc; }
/* harmony export */ });
/** Shape of assets loaded with the next.js loader */ /**
 * Helper to get the url of an asset
 *
 * Workaround to get an assets `src` URL that works with both the next.js and
 * Storybook/Jest asset loader return format.
 *
 * This is just a temporary workaround till Storybook has better support for Next.js
 * See: https://storybook.js.org/blog/integrate-nextjs-and-storybook-automatically/
 *
 * @returns the normalized url of `asset`
 */ var getSrc = function(asset) {
    return typeof asset === "string" ? asset : asset.src;
};


/***/ }),

/***/ 5169:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var cmsTheme = {
    brandColors: {
        accent: {
            bengal: "#F05B24",
            bumblebee: "#F9BE00",
            raspberry: "#AC145A"
        },
        background: {
            dark1: "#333E48",
            dark2: "#05467E",
            dark3: "#671E75",
            light1: "#F7F8FA",
            light2: "#FFFFFF"
        },
        neutral: {
            black: "#000000",
            canvas: "#F7F8FA",
            charcoal: "#333E48",
            flint: "#D0D2D3",
            slate: "#6C777D",
            stone: "#9DA5AA",
            white: "#FFFFFF"
        },
        primary: {
            arctic: "#2DCCD3",
            concord: "#671E75",
            midnight: "#05467E",
            sabaeus: "#00BF6F"
        }
    },
    endpageColors: {
        embeddedNonBranded: {
            backgroundColor: "#efefef"
        },
        onHover: {
            lighterBumblebee: "#FFCD2D",
            transparentWhite: "rgba(255, 255, 255, 0.9)"
        }
    },
    util: {
        fullHeight: "100vh"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (cmsTheme);


/***/ })

}]);